import { Injectable } from '@angular/core';
import { ApiAuthService } from './api-auth.service';
import { ToTypeOrm } from '../models/_to-type-orm.schema';

@Injectable({
  providedIn: 'root'
})
export class ProductCategoryService extends ApiAuthService {

  private readonly url = `${this.baseUrl}/product-category`;

  async getAllProductCategories(page?: number, limit?: number, order?: {}, filter: any = {}): Promise<any> {
    return this.getAll(page, limit, order, filter);
  }
  
  async getAll(page?: number, limit?: number, order?: {}, filter?: { [key: string]: ToTypeOrm }): Promise<any>{
    let params = {};
    if (page) params['page'] = page;
    if (limit) params['limit'] = limit;
    if (order) params['order'] = JSON.stringify(order);
    if (filter) params['filter'] = JSON.stringify(filter);
    return this.request(() => this.http.get(`${this.url}`, { params: params }).toPromise() );
  }

  async createProductCategory(formValues: any): Promise<any>{
    return this.request(() => this.http.post(`${this.url}`, formValues ).toPromise() );
  }

  async updateProductCategory(productCategoryId: number, formValues: any): Promise<any>{
    return this.request(() => this.http.put(`${this.url}/${productCategoryId}`, formValues ).toPromise() );
  }

  async getProductCategory(productCategoryId: number): Promise<any>{
    return this.request(() => this.http.get(`${this.url}/${productCategoryId}` ).toPromise() );
  }

  async deleteProductCategory(productCategoryId: number): Promise<any>{
    return this.request(() => this.http.delete(`${this.url}/${productCategoryId}` ).toPromise() );
  }

  
}
